import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('general'),
    avatarLabel: defineMessage('avatar'),
    firstNameLabel: defineMessage('first_name'),
    firstNamePlaceholder: defineMessage('enter_your_first_name'),
    lastNamePlaceholder: defineMessage('enter_your_last_name'),
    lastNameLabel: defineMessage('last_name'),
    phonePlaceholder: defineMessage('enter_your_phone_number'),
    phoneLabel: defineMessage('phone_1'),
    timeZonePlaceholder: defineMessage('enter_your_time_zone'),
    timeZoneLabel: defineMessage('time_zone'),
    timeZoneHint: defineMessage('this_timezone_is_used_for_email_notifications'),
    buttonEmailChange: defineMessage('change'),
    errorFirstNameRequired: defineMessage('first_name_cannot_be_empty'),
    errorFirstNameExceeded: defineMessage('first_name_cannot_be_longer_than_characters_1'),
    errorLastNameRequired: defineMessage('last_name_cannot_be_empty'),
    errorLastNameExceeded: defineMessage('last_name_cannot_be_longer_than_characters_1'),
    errorPhoneRequired: defineMessage('phone_number_cannot_be_empty'),
    errorPhoneInvalid: defineMessage('phone_number_must_contain_digits'),
    errorTimeZoneRequired: defineMessage('time_zone_cannot_be_empty'),
    errorEmailRequired: defineMessage('email_cannot_be_empty'),
    errorEmailInvalid: defineMessage('email_format_is_invalid'),
};
